import React, { useMemo } from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import moment from 'moment';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';
import { WrapperTabela } from '~/pages/RelPitStopControleAbastecimento/components/Table/styles';

export default function TablePitStopRecebimentoAreia({ rows }) {
  const formatNumber = (value, decimals) =>
    value == null ? '' : number(value, decimals);

  const headers = useMemo(
    () => [
      { label: t('s.operacao.turno.datahora'), align: 'center' },
      { label: t('s.geral.postocomboio'), align: 'left' },
      { label: t('s.relatorio.geral.notafiscal'), align: 'left' },
      { label: t('s.relatorio.descarga.pedido'), align: 'left' },
      { label: t('s.geral.fornecedor'), align: 'left' },
      { label: t('s.operacao.recebimento.placactdescarga'), align: 'left' },
      {
        label: t('s.geral.pesonf'),
        align: 'right',
      },
      {
        label: t('s.relatorio.pitstop.quantidadenf'),
        align: 'right',
      },
      {
        label: t('s.relatorio.pitstop.pesomedido'),
        align: 'right',
      },
      { label: t('s.cadastro.usuario.usuario'), align: 'left' },
    ],
    []
  );

  return (
    <WrapperTabela height="80vh">
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell
                  align={header.align}
                  key={`cell-index-head-${index}`}
                >
                  {header.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow hover tabIndex={-1} key={`table-row-body-${index}`}>
                <TableCell align="center">
                  {row.datachegadarecebimentoareianf
                    ? moment(row.datachegadarecebimentoareianf).format(
                        'DD/MM/YYYY HH:mm:ss'
                      )
                    : ''}
                </TableCell>
                <TableCell>{row.codigonomeposto}</TableCell>
                <TableCell>{row.numeronfrecebimentoareianf}</TableCell>
                <TableCell>{row.numeropedidorecebimentoareianf}</TableCell>
                <TableCell>{row.nomedistribuidoranfe}</TableCell>
                <TableCell>{row.placactrecebimentoareianf}</TableCell>
                <TableCell align="right">
                  {formatNumber(row.quantidaderecebimentoareianf, 2)}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(
                    row.quantidadesacosrecebimentoareianfitem,
                    2
                  )}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(row.pesototalkgrecebimentoareianfitem, 2)}
                </TableCell>
                <TableCell>{row.nomeusuariorecebimentoareianf}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </WrapperTabela>
  );
}

TablePitStopRecebimentoAreia.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
};